//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'TermoAceiteRealizado',
  data() {
    return {
      termoAceiteResources: this.$api.termoAceite(this.$resource),

      items: [],
      termo: {},
      pagination: {
        rowsPerPage: 10,
      },
      totalPage: 0,
      searchQuery: '',
    };
  },
  computed: {
  },
  watch: {
    searchQuery() {
      if (this.timeoutTemp) {
        window.clearTimeout(this.timeoutTemp);
      }
      this.timeoutTemp = window.setTimeout(() => {
        this.buscarTermos();
      }, 500);
    },
    pagination: {
      handler() {
        this.buscarTermos();
      },
      deep: true,
    },
  },
  methods: {
    buscarTermos() {
      const params = {
        tamanhoPagina: this.pagination.itemsPerPage || 10,
        numeroPagina: this.pagination.page || 1,
        filter: this.searchQuery,
      };

      this.termoAceiteResources.listarRealizados(params).then((response) => {
        this.items = response.data.resposta;
        this.totalPage = response.data.quantidadeRegistrosPagina;
      }, (err) => {
        this.$error(this, err);
      });
    },
    selecionar(item) {
      this.termo = item;
    },
  },
  mounted() {
  },
};



// WEBPACK FOOTER //
// ./src/spa/termo-aceite/TermoAceiteRealizado.vue?vue&type=script&lang=js&